import { useAppActions } from 'reducers/slices/administrators/loanOfficerSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';
import { useSelector } from 'react-redux';

export default () => {
  const { updateLoanOfficer, approveLoanOfficer } = useAppActions();
  const { loanOfficerUpdatingStatus, loanOfficerApprovingStatus } = useSelector(
    state => state.administratorsLoanOfficerSlice,
  );

  return {
    updateLoanOfficer,
    isLoanOfficerUpdating: useFetchStatus(loanOfficerUpdatingStatus).isPending,
    approveLoanOfficer,
    isLoanOfficerApproving: useFetchStatus(loanOfficerApprovingStatus).isPending,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/administrators/useLoanOfficer.js